import { useEffect } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Row, Col, Spin } from 'antd'
import GeneralInfos from './generalInfos';
import MostPatientsBarCharts from './mostPatientsBarCharts';
import DailyStatistics from './dailyStatistics';
import WeeklyStatistics from './weeklyStatistics';
import IntlMessages from '../../components/utility/intlMessages';
import systemActions from '../../redux/systemInfos/actions';
import { getSortedClinicsWithMostPatients, getSortedUsersWithMostPatients } from '../../redux/systemInfos/selectors';
import BackgroundLogs from './backgroundLogs';
import GeneralLog from './generalLogs';

const {
  getClinicsWithMostPatients, getUsersWithMostPatients, getBackgroundLogs
} = systemActions;

function HomePage(props) {
  useEffect(() => {
    props.getClinicsWithMostPatients();
    props.getUsersWithMostPatients();
    props.getBackgroundLogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Spin spinning={props.loading > 0}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <GeneralInfos />
          </Col>
        </Row>

        <Row gutter={[32, 16]}>
          {props.clinicsWithMostPatients.length !== 0 && <Col xs={24} lg={12}>
            <MostPatientsBarCharts
              chartTitle={<IntlMessages id="homePage.clinicsWithMostPatients.chartTitle" />}
              data={props.clinicsWithMostPatients}
              indexBy={'title'}
            />
          </Col>}

          {props.usersWithMostPatients.length !== 0 && <Col xs={24} lg={12}>
            <MostPatientsBarCharts
              chartTitle={<IntlMessages id="homePage.usersWithMostPatients.chartTitle" />}
              data={props.usersWithMostPatients}
              indexBy={'title'}
            />
          </Col>}
        </Row>

        <Row gutter={[32, 16]}>
          <Col xs={24} lg={12}>
            <DailyStatistics/>
          </Col>
          <Col xs={24} lg={12}>
            <WeeklyStatistics/>
          </Col>
        </Row>

        <Row gutter={[32, 16]}>
          <Col xs={24} xxl={12}>
            <BackgroundLogs data={props.backgroundLogs} />
          </Col>

          <Col xs={24} xxl={12}>
            <GeneralLog />
          </Col>
        </Row>
      </Spin>
    </>
  )
}

HomePage.propTypes = {
  clinicsWithMostPatients: PropTypes.array.isRequired,
  usersWithMostPatients: PropTypes.array.isRequired,
  loading: PropTypes.number.isRequired,

  getClinicsWithMostPatients: PropTypes.func.isRequired,
  getBackgroundLogs: PropTypes.func.isRequired,
  getUsersWithMostPatients: PropTypes.func.isRequired,
};

HomePage.defaultProps = {
  clinicsWithMostPatients: [],
  usersWithMostPatients: []
}

const mapActionsToProps = {
  getClinicsWithMostPatients,
  getUsersWithMostPatients,
  getBackgroundLogs
};

function mapStateToProps(state) {
  return {
    clinicsWithMostPatients: getSortedClinicsWithMostPatients(state),
    usersWithMostPatients: getSortedUsersWithMostPatients(state),
    loading: state.SystemInfos.get('loading'),
    backgroundLogs: state.SystemInfos.get('backgroundLogs'),
  };
}

const connectedHomePage = connect(mapStateToProps, mapActionsToProps)(HomePage);
export default connectedHomePage;